// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"cead9a91","649":"5f40b7f1","862":"ca3631ef"}[chunkId] + ".chunk.js";
};